/* 三國逗陣打 · 真三國無雙 3.7D 技能機制（掛在模擬層 World 上，不碰 DOM）
 * 技能資料裡的 x（主動）與 pv（被動）是明確參數，不再從說明文字解析；陣列一律是「各級數值」。
 *   x.k：nuke 指定單體、multi 多目標、aoe 範圍、buff 增益／減益、zone 持續區域、summon 召喚、line 直線貫穿、
 *        blinkhit 閃擊、pullally 護駕、fullheal 代價、healwave 醫療波、vision 視野、dispel 驅散、meteor 隕石雨
 *   沒有 x.k 時沿用原型（arch）的動作，只換成 x 的傷害與控制。 */
// @ts-nocheck — 第 2 步只把檔案改成模組，型別在第 4 步補
import { SG } from './sg.ts';
import { at } from './hooks.ts';

const W = SG.World.prototype, L = SG.L, K = SG.K;
const { move, landing, mkStatus } = SG._sim;
const gd = SG.gd, dirTo = SG.dirTo, along = SG.along;
const sign = (v) => (v > 0 ? 1 : v < 0 ? -1 : 0);
const H_AURA = at('aura');

// 依等級把參數攤平；slow 寫成 {amt, dur}，轉成模擬層用的 [比例, 秒數]
function resolve(v, lvl) {
  if (Array.isArray(v)) return L(v, lvl);
  if (v && typeof v === 'object') { const r = {}; for (const k in v) r[k] = resolve(v[k], lvl); return r; }
  return v;
}
SG.xcc = function (sk, lvl) {
  if (!sk.x.cc) return null;
  const c = resolve(sk.x.cc, lvl);
  if (c.slow && !Array.isArray(c.slow)) c.slow = [c.slow.amt / 100, c.slow.dur];
  return c;
};
const BASIC = ['atk', 'armor', 'asp', 'ms', 'sp', 'cdr', 'range'];
SG.xpv = function (sk, lvl) {
  const c = sk._xp || (sk._xp = {});
  if (c[lvl]) return c[lvl];
  const p = resolve(sk.pv, lvl), o = { x: {} };
  for (const k of BASIC) o[k] = p[k] || 0;
  if (p.multi) o.multi = p.multi;
  if (p.burnHit) o.burnHit = p.burnHit;
  for (const k in p) if (!BASIC.includes(k) && k !== 'multi' && k !== 'burnHit') o.x[k] = p[k];
  return (c[lvl] = o);
};

// ---------- 被動 ----------
W.xRecalc = function (u) {
  if (u.kind !== 'hero' || !u.spec.skills) { return; }
  const px = { evade: 0, crits: [], cleave: 0, bonus: [], reflect: 0, regen: 0, regenP: 0, auras: [], orb: 0, poison: null, lowHp: null, rebirth: 0, boom: null, manaKill: 0, resist: 0 };
  let str = 0, msP = 0, atkP = 0, any = false;
  u.spec.skills.forEach((sk, i) => {
    if (!sk.pv || !u.skillLv[i]) return;
    any = true;
    const e = SG.xpv(sk, u.skillLv[i]).x;
    if (e.evade) px.evade = 1 - (1 - px.evade) * (1 - e.evade / 100);
    if (e.crit) px.crits.push(e.crit);
    if (e.cleave) px.cleave = Math.max(px.cleave, e.cleave / 100);
    if (e.bonus) px.bonus.push(e.bonus);
    if (e.reflect) px.reflect += e.reflect / 100;
    if (e.regen) px.regen += e.regen;
    if (e.regenP) px.regenP += e.regenP;
    if (e.aura) px.auras.push(Object.assign({ key: u.id + ':' + i }, e.aura));
    if (e.orb) px.orb += e.orb;
    if (e.poison) px.poison = e.poison;
    if (e.lowHp) px.lowHp = e.lowHp;
    if (e.rebirth) px.rebirth = e.rebirth;
    if (e.boom) px.boom = e.boom;
    if (e.manaKill) px.manaKill += e.manaKill;
    if (e.resist) px.resist += e.resist / 100;
    str += e.str || 0; msP += e.msP || 0; atkP += e.atkP || 0;
  });
  u.px = any ? px : null;
  if (str) { u.maxHp += str * 20; u.atk += str; u.str = (u.str || 0) + str; } // 也算進武力（技能成長）
  if (atkP) u.atk = Math.round(u.atk * (1 + atkP / 100));
  if (msP) u.ms = Math.round(u.ms * (1 + msP / 100));
  if (u.buffs) for (const b of u.buffs) if (b.hp) u.maxHp += b.hp;
};
W.xArmor = function (t) {
  let a = t.armor;
  if (t.unarmor > 0) a -= 5; // 謀略「卸甲」
  if (t.ashredN && this.t < (t.ashredT || 0)) a -= t.ashredN * (t.ashredAmt || 2); // 破甲錐「削甲」
  if (t.bf) a += t.bf.armor;
  if (t.px && t.px.lowHp && t.hp / t.maxHp < t.px.lowHp.below / 100) a += t.px.lowHp.armor;
  return a;
};
W.xCrit = function (u, dmg, a) {
  const px = u.px;
  const snipe = u.snipeUntil > this.t ? u.snipeMult : 0; // 夏侯淵「狙擊」：必定爆擊
  if (!px && !snipe) return dmg;
  let m = snipe || 1;
  if (px) for (const c of px.crits) if (SG.rand() < c.chance / 100) m = Math.max(m, c.mult);
  if (m > 1 && (u.human || (a.target && a.target.human))) this.dmgEvents.push({ x: u.x, y: u.y - 70, text: `爆擊 ×${m}`, team: 1 - u.team, src: u.id });
  return dmg * m + (px ? px.orb : 0);
};
W.xHit = function (u, t) {
  const px = u.px;
  for (const b of px.bonus) if (SG.rand() < b.chance / 100) {
    this.damage(u, t, b.dmg, { magic: true });
    if (b.stun && t.alive) this.applyCC(u, t, { stun: b.stun });
  }
  if (px.poison && t.alive && !t.structure) {
    if (px.poison.dps) this.xDot(u, t, px.poison.dps, px.poison.dur, 'poison');
    if (px.poison.slow) this.addBuff(t, { id: 'poison:' + u.id, t: px.poison.dur, ms: -px.poison.slow / 100, neg: true });
  }
};
W.xPreDamage = function (src, t, o) {
  if (o.spell && t.bf && t.bf.immune) return false;
  if (o.basic && t.px && t.px.evade && SG.rand() < t.px.evade) {
    if (t.human || src.human) this.dmgEvents.push({ x: t.x, y: t.y - 60, text: '閃避', team: t.team, src: src.id, tgt: t.id });
    return false;
  }
  return true;
};
W.xPost = function (src, t, a, o) {
  if (t.sleeping && a > 1) { t.sleeping = false; t.st.stun = 0; }
  if (!o.basic || a <= 0) return;
  if (t.px && t.px.reflect && !src.ranged && !src.structure && src.alive) this.damage(t, src, a * t.px.reflect, { magic: true, quiet: true });
  const ls = src.bf ? src.bf.ls : 0;
  if (ls > 0 && !t.structure) this.heal(src, a * ls);
};
W.xPreKill = function (src, t) {
  const px = t.px;
  if (t.kind === 'hero' && px && px.rebirth && !(t.rebirthCd > 0)) {
    t.rebirthCd = px.rebirth * SG.CD_SCALE;
    t.hp = t.maxHp; t.mp = t.maxMp; t.st = mkStatus(); t.sleeping = false; t.dots = null;
    this.fx({ k: 'heal', x: t.x, y: t.y, col: t.spec.fx });
    this.say(`${t.name} 重生！`, 'info');
    return true;
  }
  if (px && px.boom && !t.booming) { t.booming = true; this.aoe(t, t.x, t.y, px.boom.r, px.boom.dmg, { magic: true, spell: true, falloff: [t.x, t.y, px.boom.r] }); this.fx({ k: 'slam', x: t.x, y: t.y, col: '#ff9a4a' }); t.booming = false; }
  if (src && src.px && src.px.manaKill && src !== t && !SG.isNeng(src)) src.mp = Math.min(src.maxMp, src.mp + src.px.manaKill);
  if (t.buffs) { const hp = t.buffs.some((b) => b.hp); t.buffs = null; t.bf = null; if (hp && t.kind === 'hero') { t.maxHp = SG.stats(t.spec, t.lv, t.items).hp; } }
  t.dots = null; t.sleeping = false;
  return false;
};

// ---------- 增益／減益 ----------
const SUM = ['as', 'ms', 'atkP', 'atk', 'armor', 'taken', 'multi', 'mpR', 'ls', 'regen'];
SG._rebuildBuffs = (u) => rebuild(u); // 武將檔（賈詡）驅散增益後要重算
function rebuild(u) {
  if (!u.buffs || !u.buffs.length) { u.buffs = null; u.bf = null; return; }
  const f = { as: 0, ms: 0, msUp: 0, atkP: 0, atk: 0, armor: 0, taken: 0, multi: 0, mpR: 0, ls: 0, regen: 0, immune: false };
  for (const b of u.buffs) {
    for (const k of SUM) if (b[k]) f[k] = k === 'multi' ? Math.max(f[k], b[k]) : f[k] + b[k];
    if (b.ms > 0) { f.ms -= b.ms; f.msUp = Math.max(f.msUp, b.ms); } // 移速：ms 只留緩速（相加），加成只取最大的 msUp（v0.4.2.1）
    if (b.immune) f.immune = true;
  }
  u.bf = f;
}
W.addBuff = function (u, b) {
  if (!u.alive || u.structure) return;
  if (b.neg && u.bf && u.bf.immune) return;
  if (!u.buffs) u.buffs = [];
  const i = u.buffs.findIndex((o) => o.id === b.id);
  if (i >= 0) { const old = u.buffs[i]; if (old.hp) { u.maxHp -= old.hp; u.hp = Math.min(u.hp, u.maxHp); } u.buffs.splice(i, 1); }
  if (b.hp) { u.maxHp += b.hp; u.hp += b.hp; }
  if (b.immune) { const s = u.st; s.stun = s.root = s.slow = s.fear = s.silence = s.freeze = s.taunt = s.charm = s.confuse = s.disarm = 0; u.sleeping = false; u.buffs = u.buffs.filter((o) => !o.neg); }
  u.buffs.push(b);
  rebuild(u);
};
W.xDot = function (src, t, dps, dur, tag) {
  if (!t.dots) t.dots = [];
  const o = t.dots.find((d) => d.tag === tag && d.src === src);
  if (o) { o.t = dur; o.dps = dps; } else t.dots.push({ src, dps, t: dur, tag });
};
W.xTickUnit = function (u, dt) {
  if (u.buffs) {
    let ch = false;
    const list = u.buffs;
    for (const b of list) {
      b.t -= dt;
      if (b.aoe) {
        b.acc = (b.acc || 0) + dt;
        if (b.acc >= 0.5) {
          b.acc -= 0.5;
          let n = 0;
          this.enemiesNear(u, u.x, u.y, b.aoe.r).forEach((t) => { if (t.structure && !b.aoe.bld) return; n++; this.damage(b.src || u, t, b.aoe.dps * 0.5, { magic: true, spell: true, quiet: true }); });
          if (b.aoe.drain && n) this.heal(u, b.aoe.drain * n * 0.5);
          this.fx({ k: 'spark', x: u.x, y: u.y - 20, col: b.col || (u.spec && u.spec.fx) });
        }
      }
      if (u.buffs !== list) break; // 範圍傷害連鎖害死自己（例如炸死會爆炸的敵人）：死亡已清空增益、生命上限也重算了
      if (b.t <= 0) { ch = true; if (b.hp) { u.maxHp -= b.hp; u.hp = Math.min(u.hp, u.maxHp); } }
    }
    if (ch && u.buffs === list) { u.buffs = list.filter((b) => b.t > 0); rebuild(u); }
  }
  if (u.dots) {
    u.dots = u.dots.filter((d) => { d.t -= dt; if (d.src) this.damage(d.src, u, d.dps * dt, { magic: true, spell: true, quiet: true }); return d.t > 0 && u.alive; });
    if (!u.dots.length) u.dots = null;
    if (!u.alive) return;
  }
  const px = u.px, bf = u.bf;
  if (u.rebirthCd > 0) u.rebirthCd -= dt;
  const regen = (px ? px.regen + u.maxHp * 0.004 * px.regenP / 100 : 0) + (bf ? bf.regen : 0);
  if (regen) u.hp = Math.min(u.maxHp, u.hp + regen * dt);
  if (bf && bf.mpR && u.maxMp && !SG.isNeng(u)) u.mp = Math.min(u.maxMp, u.mp + u.maxMp * 0.012 * bf.mpR / 100 * dt);
};
// 光環：每 0.5 秒刷新一次範圍內單位身上的效果
W.xAuras = function (dt) {
  this._auraT = (this._auraT || 0) - dt;
  if (this._auraT > 0) return;
  this._auraT = 0.5;
  for (const h of H_AURA) h.fn.call(this); // 武將的光環型被動（周倉「忠心」、小喬「紅顏」）
  for (const u of this.units) {
    if (!u.alive || !u.px || !u.px.auras.length) continue;
    for (const a of u.px.auras) {
      if (a.armor || a.atkP || a.mpR || a.ls) this.alliesNear(u, a.r).forEach((t) => this.addBuff(t, { id: 'aura:' + a.key, t: 0.8, armor: a.armor || 0, atkP: (a.atkP || 0) / 100, mpR: a.mpR || 0, ls: (a.ls || 0) / 100 }));
      if (a.slow) this.enemiesNear(u, u.x, u.y, a.r).forEach((t) => { if (!t.structure) this.addBuff(t, { id: 'aura:' + a.key, t: 0.8, ms: -a.slow / 100, neg: true }); });
    }
  }
};
W.xStill = function (u) {
  const I = u.input;
  I.moveTo = null;
  if (I.target && !this.inRange(u, I.target)) I.target = null;
  if (!I.target) { let best = null, bd = u.range; for (const t of this.units) { if (!this.isEnemy(u, t) || t.structure) continue; const d = gd(u.x, u.y, t.x, t.y) - t.r; if (d < bd) { bd = d; best = t; } } I.target = best; }
};
// 持續區域的額外行為：跟隨單位、治療友軍、地雷、隨機控制
W.xZone = function (z, dt) {
  const e = z.x2, o = z.owner;
  if (e.follow) { if (!e.follow.alive) return false; z.x = e.follow.x; z.y = e.follow.y; }
  if (e.healP) for (const t of this.units) if (t.alive && t.team === z.team && !t.structure && t.kind !== 'ward' && gd(z.x, z.y, t.x, t.y) <= z.r) t.hp = Math.min(t.maxHp, t.hp + t.maxHp * e.healP / 100 * dt);
  if (e.mine) {
    e.arm = (e.arm == null ? 0.8 : e.arm) - dt;
    if (e.arm <= 0 && (e.fuse ? z.t <= dt * 2 || (o.alive && e.detonate) : this.enemiesNear(o, z.x, z.y, e.trig || z.r * 0.5).some((t) => !t.structure && (!e.heroOnly || t.kind === 'hero')))) {
      this.enemiesNear(o, z.x, z.y, z.r).forEach((t) => { if (t.structure) return; this.damage(o, t, e.mine, { magic: true, spell: true, stagger: 0.4 }); if (e.cc) this.applyCC(o, t, e.cc); });
      this.fx({ k: 'slam', x: z.x, y: z.y, col: '#ff9a4a' }); this.fx({ k: 'fire', x: z.x, y: z.y, pal: 'fire' });
      return false;
    }
  }
  if (e.rcc) this.enemiesNear(o, z.x, z.y, z.r).forEach((t) => { if (!t.structure && SG.rand() < e.p * dt) this.applyCC(o, t, e.rcc); });
  if (e.silence) this.enemiesNear(o, z.x, z.y, z.r).forEach((t) => { if (!(t.bf && t.bf.immune)) t.st.silence = Math.max(t.st.silence, 0.3); });
  if (e.pctDps) this.enemiesNear(o, z.x, z.y, z.r).forEach((t) => { if (!t.structure && t.kind !== 'boss') this.damage(o, t, t.maxHp * e.pctDps / 100 * dt, { magic: true, spell: true, quiet: true }); });
  return true;
};

// ---------- 主動技能 ----------
W.xPick = function (u, pt, r, noHero) {
  // 點擊技：施放時點選的目標必中（不看施放點附近有誰）
  const a = this._xa;
  if (a && a.tid) { const t = this.units.find((o) => o.id === a.tid); if (t && t.alive && (t.team === u.team || this.isEnemy(u, t) || t.team === 2) && !(noHero && (t.kind === 'hero' || t.kind === 'boss' || t.image))) return t; }
  let best = null, bs = 1e9;
  for (const t of this.units) {
    if (!this.isEnemy(u, t) || t.structure || t.kind === 'cart') continue;
    if (noHero && (t.kind === 'hero' || t.kind === 'boss' || t.image)) continue;
    const d = gd(pt[0], pt[1], t.x, t.y);
    if (d > r + t.r) continue;
    const s = d - (t.kind === 'hero' ? 120 : 0);
    if (s < bs) { bs = s; best = t; }
  }
  return best;
};
W.xAlly = function (u, pt, R, self) {
  const hs = this.units.filter((t) => t.alive && t.team === u.team && t.kind === 'hero' && (self || t !== u) && gd(u.x, u.y, t.x, t.y) <= R + 60);
  if (!hs.length) return self ? u : null;
  const near = hs.filter((t) => t !== u && gd(pt[0], pt[1], t.x, t.y) < 130).sort((a, b) => gd(pt[0], pt[1], a.x, a.y) - gd(pt[0], pt[1], b.x, b.y))[0];
  return near || hs.sort((a, b) => a.hp / a.maxHp - b.hp / b.maxHp)[0];
};
W.xRefund = function (u, a) { u.cd[a.i] = 1; u.mp = Math.min(u.maxMp, u.mp + this.skillCost(a.i, a.lvl, a.sk)); this.tell(u, '沒有目標', 'warn'); };
// 對單一目標套用一個技能的全部效果
W.xApply = function (u, t, X, a, mul, stagger = 0.3) {
  if (!t.alive) return;
  if (t.bf && t.bf.immune && !X.phys) return;
  let dmg = (X.dmg || 0) * SG.spMul(u) * (mul == null ? 1 : mul);
  if (X.atkMul) dmg += this.atkPower(u) * X.atkMul;
  if (X.intMul && (t.maxMp || SG.noRes(t))) dmg += (SG.isNeng(t) || SG.noRes(t) ? t.int : (t.maxMp - 50) / 12) * X.intMul; // 能武將的上限固定 100，智力直接讀
  if (X.burn && t.maxMp && !SG.isNeng(t)) { const m = Math.min(t.mp, X.burn); t.mp -= m; dmg += m; }
  if (X.extra && SG.rand() < X.extra.chance / 100) dmg += X.extra.dmg;
  if (X.kill && (t.kind === 'minion' || t.kind === 'creep')) dmg = t.hp + 1;
  if (X.charm && (t.kind === 'minion' || t.kind === 'creep')) { this.xCharm(u, t, X); return; }
  if (dmg > 0) this.damage(u, t, dmg, { magic: !X.phys, spell: !X.phys, stagger });
  if (!t.alive) return;
  if (a.cc) this.applyCC(u, t, a.cc);
  if (X.interrupt && t.act && t.kind !== 'boss') { t.act = null; t.anim = 'hit'; t.animSeq++; } // 打斷：連施法中的技能也中斷
  if (X.sleep && t.kind !== 'boss') { t.st.stun = Math.max(t.st.stun, X.sleep); t.sleeping = true; t.act = null; }
  if (X.debuff) { const d = X.debuff; this.addBuff(t, { id: 'dbf:' + a.sk.name, t: d.dur, neg: true, as: -(d.as || 0), ms: -(d.ms || 0) / 100, atkP: -(d.atkP || 0) / 100, armor: -(d.armor || 0), atk: -(d.atk || 0) }); }
  if (X.dot) this.xDot(u, t, X.dot.dps, X.dot.dur, a.sk.name);
  if (X.purge) { if (t.buffs) { t.buffs = t.buffs.filter((b) => b.neg || /^aura:/.test(b.id)); rebuild(t); } if (t.summon && X.purge > 1 && t.alive) this.damage(u, t, X.purge, { magic: true }); } // 召喚物一律受傷（老虎不限時、沒增益的也算）
  if (X.reveal) t.revealT = this.t + X.reveal;
  if (X.drain) this.heal(u, dmg);
  if (X.leech) { this.xDot(u, t, X.leech.dps, X.leech.dur, a.sk.name); this.addBuff(u, { id: a.sk.name, t: X.leech.dur, regen: X.leech.dps }); }
};
W.xCharm = function (u, t, X) {
  t.team = u.team; t.owner = u; t.home = null; t.path = null; t.lane = null; t.aggro = null; t.target = null; t.kind = 'minion'; t.temp = X.charm; t.vis = [true, true];
  this.fx({ k: 'heal', x: t.x, y: t.y, col: '#ff8ad0' });
};
W.xFx = function (u, X, x, y, r) {
  const col = X.col || u.spec.fx, f = X.fx || 'spark';
  if (f === 'thunder') this.fx({ k: 'thunder', x, y, col });
  else if (f === 'fire') this.fx({ k: 'fire', x, y, pal: X.pal || 'fire' });
  else if (f === 'ice') this.fx({ k: 'fire', x, y, pal: 'ice' });
  else if (f === 'slam') this.fx({ k: 'slam', x, y, col });
  else if (f === 'heal') this.fx({ k: 'heal', x, y, col });
  else if (f === 'rain') this.fx({ k: 'rain', x, y, col });
  else this.fx({ k: 'spark', x, y: y - 20, col });
};
W.xSkill = function (u, a, kp, k, dt, cross) {
  const sk = a.sk, x = sk.x;
  if (!cross(x.at || 0.4)) return;
  const X = a.X || (a.X = resolve(x, a.lvl));
  const fn = this['x_' + x.k];
  if (fn) fn.call(this, u, a, X);
};

W.x_nuke = function (u, a, X) {
  const R = this.skillRange(a.sk, a.lvl);
  const t = this.xPick(u, a.pt, X.pick || 150, X.noHero);
  // click：點擊技，點友軍治療、點敵人傷害（v0.4.2 劉備「聖光術」）；電腦沒有點選目標，照舊優先治療受傷的友軍
  if (X.heal && X.click && a.tid && t && t.team === u.team) { this.heal(t, X.heal); this.fx({ k: 'heal', x: t.x, y: t.y, col: u.spec.fx }); return; }
  if (X.heal && (!t || X.allyFirst || (X.click && !a.tid))) {
    const al = this.xAlly(u, a.pt, R, true);
    if (al && (al.hp < al.maxHp * 0.97 || !t)) { this.heal(al, X.heal); this.fx({ k: 'heal', x: al.x, y: al.y, col: u.spec.fx }); return; }
  }
  if (!t) { this.xRefund(u, a); return; }
  const hit = (o, mul) => { this.xApply(u, o, X, a, mul); this.xFx(u, X, o.x, o.y); };
  const go = () => {
    if (!t.alive) return;
    hit(t, X.heal && !X.dmg ? 0 : 1);
    if (X.heal && !X.dmg && t.alive) this.damage(u, t, X.heal / 2 * SG.spMul(u), { magic: true, spell: true, stagger: 0.2 });
    if (X.bounce) {
      const seen = { [t.id]: 1 };
      let cur = t, mul = 1;
      for (let j = 1; j <= X.bounce.n; j++) {
        const nx = this.units.filter((o) => this.isEnemy(u, o) && !o.structure && !seen[o.id] && gd(cur.x, cur.y, o.x, o.y) < (X.bounce.r || 380)).sort((p, q) => gd(cur.x, cur.y, p.x, p.y) - gd(cur.x, cur.y, q.x, q.y))[0];
        if (!nx) break;
        seen[nx.id] = 1; cur = nx; mul *= 1 - (X.bounce.decay || 0.15);
        const o = nx, m = mul;
        this.later(0.12 * j, () => hit(o, m));
      }
    }
    if (X.splash) this.enemiesNear(u, t.x, t.y, X.splash.r).forEach((o) => { if (o !== t && !o.structure) { this.damage(u, o, X.splash.dmg * SG.spMul(u), { magic: true, spell: true, stagger: 0.2 }); if (a.cc) this.applyCC(u, o, a.cc); } });
  };
  if (X.delay) { this.fx({ k: 'warn', x: t.x, y: t.y, r: 50, t: X.delay }); this.later(X.delay, go); } else go();
};
W.x_aoe = function (u, a, X) {
  const c = X.self ? [u.x, u.y] : a.pt;
  if (X.immuneSelf) this.addBuff(u, { id: a.sk.name, t: X.immuneSelf, immune: true });
  const go = () => {
    const crowd = X.crowd ? Math.min(2.4, 1 + X.crowd * (this.enemiesNear(u, c[0], c[1], X.r).filter((t) => !t.structure).length - 1)) : 1;
    this.enemiesNear(u, c[0], c[1], X.r).forEach((t) => {
      if ((t.structure && !X.bld) || (X.ground && t.air)) return;
      const mul = (X.falloff ? 1 - 0.6 * Math.min(1, gd(c[0], c[1], t.x, t.y) / X.r) : 1) * (t.structure ? 0.5 : 1) * crowd;
      if (t.structure) this.damage(u, t, X.dmg * mul, { magic: true }); else this.xApply(u, t, X, a, mul);
    });
    this.xFx(u, X, c[0], c[1]);
    if (X.burnZone) this.zone(u, { x: c[0], y: c[1], r: X.r, t: X.burnZone.dur, tick: 0.5, dmg: X.burnZone.dps * 0.5, ground: true, fire: true, pal: 'fire' });
  };
  if (X.delay) { this.fx({ k: 'warn', x: c[0], y: c[1], r: X.r, t: X.delay }); this.later(X.delay, go); } else go();
};
W.x_buff = function (u, a, X) {
  const R = this.skillRange(a.sk, a.lvl);
  let ts;
  if (X.to === 'ally') ts = [this.xAlly(u, a.pt, R, true)];
  else if (X.to === 'near') ts = this.alliesNear(u, X.r || 500);
  else if (X.to === 'all') ts = this.units.filter((t) => t.alive && t.team === u.team && !t.structure && t.kind !== 'ward' && t.kind !== 'cart');
  else if (X.to === 'foes') ts = this.units.filter((t) => t.alive && t.team === 1 - u.team && !t.structure && t.kind !== 'ward' && t.kind !== 'cart');
  else if (X.to === 'foesNear') ts = this.enemiesNear(u, X.self ? u.x : a.pt[0], X.self ? u.y : a.pt[1], X.r || 300).filter((t) => !t.structure);
  else ts = [u];
  if (X.heroOnly) ts = ts.filter((t) => t.kind === 'hero');
  const neg = X.to === 'foes' || X.to === 'foesNear';
  ts.forEach((t) => {
    this.addBuff(t, { id: a.sk.name, t: X.dur, src: u, neg, as: X.as || 0, ms: (X.ms || 0) / 100, atkP: (X.atkP || 0) / 100, atk: X.atk || 0, armor: X.armor || 0, taken: (X.taken || 0) / 100,
      immune: !!X.immune, multi: X.multi || 0, hp: X.hp || 0, regen: X.regen || 0, ls: (X.ls || 0) / 100, aoe: X.aoe || null, col: u.spec.fx });
    if (X.heal) this.heal(t, X.heal);
    if (t.kind === 'hero') this.fx({ k: neg ? 'spark' : 'heal', x: t.x, y: t.y, col: u.spec.fx });
  });
  if (X.wind) this.startWind(X.wind);
};
W.x_zone = function (u, a, X) {
  const t = X.onUnit ? (this.xPick(u, a.pt, 150) || (X.onUnit === 'any' ? this.xAlly(u, a.pt, this.skillRange(a.sk, a.lvl), true) : null)) : null;
  if (X.onUnit && !t) { this.xRefund(u, a); return; }
  const c = X.self ? [u.x, u.y] : t ? [t.x, t.y] : a.pt;
  const x2 = {};
  let has = false;
  for (const k of ['healP', 'mine', 'rcc', 'p', 'silence', 'pctDps', 'fuse', 'trig', 'cc', 'heroOnly']) if (X[k] != null) { x2[k] = X[k]; has = true; }
  if (t) { x2.follow = t; has = true; }
  if (X.followSelf) { x2.follow = u; has = true; }
  const tick = X.tick || 0.5;
  this.zone(u, { x: c[0], y: c[1], r: X.r, t: X.dur, tick, dmg: (X.dps || 0) * tick * SG.spMul(u), slow: X.slow ? X.slow / 100 : 0, ground: true, fire: X.pal === 'fire', pal: X.pal || null,
    cc: X.zcc || null, x2: has ? x2 : null, name: a.sk.name, look: X.look || null }); // look：只影響畫面（例如龐統的龍捲風）
  this.xFx(u, X, c[0], c[1]);
  if (X.fuse) u.fuses = (u.fuses || []).concat([this.zones[this.zones.length - 1]]);
};
W.x_detonate = function (u) { (u.fuses || []).forEach((z) => { if (z.x2) z.x2.detonate = true; }); u.fuses = []; };
// 召喚獸的造型大小（血條高度跟著；連線時客戶端也用這張表）
SG.BEAST_SIZE = { tiger: 1, water: 1, elephant: 1.55, waterking: 1.75, spirit: 1, zombie: 1, golem: 1.45, snake: 0.95, tower: 1.35, hubao: 1.3 };
W.x_summon = function (u, a, X) {
  const n = X.n || 1, c = X.self ? [u.x + u.f * 50, u.y] : a.pt;
  for (let j = 0; j < n; j++) {
    const ang = (j / n) * Math.PI * 2, rr = n > 1 ? (X.spread || 46) : 0;
    const p = landing(u.x, u.y, c[0] + Math.cos(ang) * rr, c[1] + Math.sin(ang) * rr * K);
    if (X.max) { // 數量上限：超過就讓最舊的一隻離場
      const mine = this.units.filter((o) => o.alive && o.summon && o.owner === u && o.name === (X.name || a.sk.name));
      while (mine.length >= X.max) { const o = mine.shift(); o.alive = false; o.deadT = this.t; this.fx({ k: 'puff', x: o.x, y: o.y }); }
    }
    const s = this.spawnMinion(u.team, null, p[0], p[1], !!X.ranged);
    if (!X.perm) s.temp = X.dur;
    s.owner = u; s.summon = true;
    if (X.beast) { s.beast = X.beast; s.spec = { id: X.beast, name: X.name, fx: X.col || u.spec.fx }; }
    else if (X.skin) s.beast = X.skin; // 只換造型（戰象、水精靈王）：不動 spec，出手節奏照舊
    if (X.critP) s.px = { evade: 0, crits: [{ chance: X.critP, mult: X.critM }], cleave: 0, bonus: [], reflect: 0, regen: 0, regenP: 0, auras: [], orb: 0, poison: null, lowHp: null, rebirth: 0, boom: null, manaKill: 0, resist: 0 };
    if (X.image) { s.spec = u.spec; s.ranged = u.ranged; s.range = u.range; s.r = 22; s.maxHp = s.hp = u.maxHp; s.atk = u.atk * X.image; s.asp = u.asp; s.ms = u.ms; s.armor = u.armor; s.image = true; this.addBuff(s, { id: 'image', t: X.dur + 1, taken: (X.taken || 2) - 1 }); }
    else { s.maxHp = s.hp = X.hp; s.atk = X.atk; s.armor = X.armor || 2; if (X.ms) s.ms = X.ms; if (X.size) s.r = X.size; }
    s.name = X.name || a.sk.name;
    if (X.still) { s.still = true; s.ms = 0; s.ranged = true; s.range = X.range || 380; }
    if (X.immune) this.addBuff(s, { id: 'immune', t: X.dur + 1, immune: true });
    if (X.regen) this.addBuff(s, { id: 'regen', t: X.dur + 1, regen: X.regen });
    if (X.aoe) this.addBuff(s, { id: 'burn', t: X.dur + 1, aoe: X.aoe, src: u });
    this.fx({ k: 'puff', x: p[0], y: p[1] });
  }
  if (X.image && X.cleanse) { const st = u.st; st.slow = st.root = st.silence = st.disarm = 0; if (u.buffs) { u.buffs = u.buffs.filter((b) => !b.neg); rebuild(u); } u.dots = null; }
};
W.x_line = function (u, a, X) {
  const n = X.n || 1, R = this.skillRange(a.sk, a.lvl), dmg = (X.dmg || 0) * SG.spMul(u), col = X.col || u.spec.fx;
  for (let j = 0; j < n; j++) {
    const sp = X.fan ? (j - (n - 1) / 2) * X.fan : 0, c = Math.cos(sp), s = Math.sin(sp);
    const dir = [a.dir[0] * c - a.dir[1] * s, a.dir[0] * s + a.dir[1] * c];
    const off = X.width ? (SG.rand() - 0.5) * X.width : 0;
    const fire = () => {
      if (!u.alive && !X.persist) return;
      const o = { x: (X.fromCast ? a.from[0] : u.x) - dir[1] * off, y: (X.fromCast ? a.from[1] : u.y) + dir[0] * off * K, team: u.team, f: u.f, spec: u.spec, id: u.id, kind: u.kind, owner: u };
      this.proj(o, { dir, speed: X.speed || 760, range: R, dmg, pierce: true, rad: X.rad || 30, visual: true, shape: X.shape || 'orb', col, cc: a.cc, big: true, spell: true, burn: X.shape === 'fire' });
    };
    if (X.gap && j) this.later(X.gap * j, fire); else fire();
  }
};
// 跳眼（v0.5.0）：技能有 wardHop 的瞬移，可以點自己這一隊的眼（斥候旗等）飛過去，不打人
W.hopWard = function (u, a) {
  const t = a.tid && a.sk.wardHop ? this.units.find((o) => o.id === a.tid) : null;
  return t && t.alive && t.kind === 'ward' && t.team === u.team && !t.owl ? t : null;
};
W.hopTo = function (u, t) {
  const q = landing(u.x, u.y, t.x, t.y);
  this.fx({ k: 'puff', x: u.x, y: u.y }); u.x = q[0]; u.y = q[1]; if (Math.abs(t.x - u.x) > 1) u.f = sign(t.x - u.x); this.fx({ k: 'puff', x: u.x, y: u.y });
};
W.x_blinkhit = function (u, a, X) {
  const w = this.hopWard(u, a);
  if (w) { this.hopTo(u, w); return; }
  const t = this.xPick(u, a.pt, X.pick || 160);
  if (!t) { this.xRefund(u, a); return; }
  const q = landing(u.x, u.y, t.x - t.f * 46, t.y);
  this.fx({ k: 'puff', x: u.x, y: u.y }); u.x = q[0]; u.y = q[1]; u.f = sign(t.x - u.x) || u.f; this.fx({ k: 'puff', x: u.x, y: u.y });
  this.damage(u, t, this.xCrit(u, this.atkPower(u), { target: t }), { stagger: 0.3, basic: true });
  this.onHitProcs(u, t);
  if (X.stun && t.alive) this.applyCC(u, t, { stun: X.stun }); // 甄姬：閃擊附帶暈眩（v0.3.3）
  u.input.target = t; u.atkCd = Math.min(u.atkCd, 0.25);
};
W.x_vision = function (u, a, X) {
  const c = X.self ? [u.x, u.y] : a.pt;
  if (X.owl) {
    // 貓頭鷹：從施放者身上飛出去，到了就在上空盤旋；同時只有一隻
    this.units.forEach((o) => { if (o.owl && o.owner === u && o.alive) { o.alive = false; o.deadT = this.t; } });
    this.units.push(SG._sim.unit({ kind: 'ward', owl: true, owner: u, team: u.team, x: u.x, y: u.y, f: u.f, fly: [c[0], c[1]], life: X.dur, r: 10, hp: 1, maxHp: 1, name: '貓頭鷹' }));
    return;
  }
  this.units.push(SG._sim.unit({ kind: 'ward', team: u.team, x: c[0], y: c[1], life: X.dur, r: 10, hp: 1, maxHp: 1, follow: X.self ? u : null })); // self：視野跟著施放者（馬岱「鷹眼」）
  this.fx({ k: 'puff', x: c[0], y: c[1] });
};
W.x_meteor = function (u, a, X) {
  const c = a.pt, staggered = new Set(); // stagger1：同一次施放，每名敵人只有第一下會硬直
  for (let j = 0; j < X.n; j++) this.later((X.gap || 0.3) * j, () => {
    const ang = SG.rand() * Math.PI * 2, d = Math.sqrt(SG.rand()) * X.area;
    let px = c[0] + Math.cos(ang) * d, py = c[1] + Math.sin(ang) * d * K;
    if (X.seek) { const es = this.enemiesNear(u, c[0], c[1], X.area).filter((t) => !t.structure); if (es.length) { const t = es[Math.floor(SG.rand() * es.length)]; px = t.x; py = t.y; } } // 敢死隊：衝到敵人身邊才炸
    this.enemiesNear(u, px, py, X.r).forEach((t) => { if (t.structure && !X.bld) return; if (t.structure) this.damage(u, t, X.dmg * 0.5, { magic: true }); else { this.xApply(u, t, X, a, null, X.stagger1 && staggered.has(t) ? 0 : 0.3); staggered.add(t); } });
    this.xFx(u, X, px, py);
  });
};
W.x_blink = function (u, a, X) {
  const p = landing(u.x, u.y, a.pt[0], a.pt[1]);
  this.fx({ k: 'puff', x: u.x, y: u.y });
  if (X.carry) this.alliesNear(u, X.carry).forEach((t) => { if (t !== u && t.kind !== 'hero') { const q = landing(p[0], p[1], p[0] + (t.x - u.x), p[1] + (t.y - u.y)); t.x = q[0]; t.y = q[1]; } });
  u.x = p[0]; u.y = p[1];
  this.fx({ k: 'puff', x: u.x, y: u.y });
};
// 變身（鬼神降臨）：落點範圍傷害＋暈眩，之後一段時間強化自身
W.x_transform = function (u, a, X) {
  const p = landing(u.x, u.y, a.pt[0], a.pt[1]);
  u.x = p[0]; u.y = p[1];
  W.x_aoe.call(this, u, a, Object.assign({}, X, { self: true }));
  this.addBuff(u, { id: a.sk.name, t: X.dur, hp: X.hp, atk: X.atk, immune: true, aoe: X.aoe, src: u });
};
